module.exports = __webpack_public_path__ + "static/media/plain_anatomy.8ec99d9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/plain_anatomy.png
// module id = 1173
// module chunks = 0